import React from 'react';
import { Box, Typography } from '@mui/material';
import './Home.css'; // Importar el archivo CSS para la animación

const Home = () => {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
            }}
        >
            <Box
                component="img"
                src="/digitalCaratula.webp"
                alt="Digital404 Logo"
                sx={{
                    width: { xs: '70vw', sm: '320px', md: '380px' },
                    maxWidth: '90vw',
                    height: 'auto',
                    objectFit: 'contain',
                    mb: 2
                }}
            />
            <Typography variant="body2" className="subtitle">
                creación y desarrollo Carlos Ibarra C
            </Typography>
        </Box>
    );
};

export default Home;